import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { getMomentTz } from "@dexteel/mesf-core";
import { Box, Grid } from "@mui/material";
import { AssetCard } from "../../../controls/AssetCard";
const moment = getMomentTz();
export const LabReportHeader = () => {
  const {
    // state: { heatLabData },
  } = useHeatReportContext();
  return (
    <BorderedTablePaper style={{ minWidth: "100%" }}>
      <Box padding={1}>
        <Grid item xs={12} container spacing={2}>
          {/* Column 1 */}
          <Grid item xs={12} sm={6} md={2} container>
            <Grid item xs={12}>
              <AssetCard assetId={15} assetName={"Lab"} />
            </Grid>
          </Grid>

          {/* Column 2 */}
          {/* <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            spacing={1}
            key="col-main-data-2"
          >
            <Grid item xs={12} container direction="row" spacing={1}>
              <Grid item xs={12}>
                <TextField
                  label="Production Date"
                  value={
                    heatLabData?.ProductionDate
                      ? `${moment(heatLabData?.ProductionDate).format("MM/DD/YYYY")} - Shift ${heatLabData?.Shift} - Crew ${heatLabData?.Crew}`
                      : ""
                  }
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Sections"
                  value={heatLabData?.Sections ?? ""}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Column 3 */}
          {/* <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            spacing={1}
            key="col-main-data-3"
          >
            <Grid item xs={12} container direction="row" spacing={1}>
              <Grid item xs={12}>
                <TextField
                  label="Programmed Grade"
                  value={heatLabData?.ProgrammedGrade ?? ""}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Cast Grade"
                  value={heatLabData?.Grade ?? ""}
                  variant="outlined"
                  fullWidth
                  slotProps={{
                    input: {
                      style: {
                        color: heatLabData?.Grade
                          ? heatLabData?.Grade !== heatLabData?.ProgrammedGrade
                            ? "red"
                            : "black"
                          : "black",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </Box>
    </BorderedTablePaper>
  );
};
